export const ScrollAnchor = () => <div id="scroll-anchor" style={{
    height: '0',
    position: 'absolute',
    width: '100%',
    bottom: `${parseInt(window.innerHeight * .75)}px`,
}}></div>
